import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "/logo.png";

const Navbar = ({ onScheduleClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinkClick = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuOpen]);

  return (
    <nav className={`nav-container ${scrolled ? "scrolled" : ""}`} data-testid="navigation">
      <div className="nav-inner">
        <Link to="/" className="nav-logo" data-testid="nav-logo">
          <img src={LOGO_URL} alt="IntentLogic" />
        </Link>
        
        {/* Desktop Navigation */}
        <div className="nav-links nav-links-desktop">
          <Link to="/" className="nav-link" data-testid="nav-home">Home</Link>
          <Link to="/cdp" className="nav-link" data-testid="nav-cdp">Data Platform</Link>
          <Link to="/omnichannel" className="nav-link" data-testid="nav-messaging">Omnichannel</Link>
          <Link to="/analytics" className="nav-link" data-testid="nav-analytics">Analytics</Link>
          <Button 
            className="btn-primary"
            data-testid="nav-cta"
            onClick={onScheduleClick}
          >
            Schedule Consultation
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-btn"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation Overlay */}
      <div className={`mobile-nav-overlay ${mobileMenuOpen ? 'open' : ''}`} onClick={() => setMobileMenuOpen(false)} />
      
      {/* Mobile Navigation Menu */}
      <div className={`mobile-nav-menu ${mobileMenuOpen ? 'open' : ''}`} data-testid="mobile-nav-menu">
        <div className="mobile-nav-links">
          <Link to="/" className="mobile-nav-link" onClick={handleLinkClick}>Home</Link>
          <Link to="/cdp" className="mobile-nav-link" onClick={handleLinkClick}>Data Platform</Link>
          <Link to="/omnichannel" className="mobile-nav-link" onClick={handleLinkClick}>Omnichannel</Link>
          <Link to="/analytics" className="mobile-nav-link" onClick={handleLinkClick}>Analytics</Link>
          <div className="mobile-nav-divider" />
          <Link to="/customer-acquisition" className="mobile-nav-link" onClick={handleLinkClick}>Customer Acquisition</Link>
          <Link to="/customer-activation" className="mobile-nav-link" onClick={handleLinkClick}>Customer Activation</Link>
          <Link to="/political-advocacy" className="mobile-nav-link" onClick={handleLinkClick}>Political Advocacy</Link>
          <div className="mobile-nav-divider" />
          <Link to="/about" className="mobile-nav-link" onClick={handleLinkClick}>About Us</Link>
          <Link to="/careers" className="mobile-nav-link" onClick={handleLinkClick}>Careers</Link>
          <Link to="/contact" className="mobile-nav-link" onClick={handleLinkClick}>Contact</Link>
          <Link to="/meet-us" className="mobile-nav-link" onClick={handleLinkClick}>Meet Us</Link>
        </div>
        <div className="mobile-nav-cta">
          <Button 
            className="btn-primary"
            onClick={() => {
              setMobileMenuOpen(false);
              onScheduleClick();
            }}
          >
            Schedule Consultation
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
